import React, { useContext, useEffect, useState } from "react";
import {
  // CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  CRow,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { cilLockLocked, cilUser } from "@coreui/icons";
//
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { AuthLogin, GETAuthLogin } from "../../features/auth/Slice";
import { useDispatch, useSelector } from "react-redux";
import SuccessModel from "../../common/model/SuccessModel";
import ErrorModel from "../../common/model/ErrorModel";
import { Col, Form, Row } from "react-bootstrap";
import CButton from "../../common/buttons/CButton";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import "./Login.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faUser } from "@fortawesome/free-solid-svg-icons";
import { Context } from "../../utils/context";
import Subscription_Check_Modal from "../../common/model/subscription_check_modal/Subscription_Check_Modal";
import Orange_Btn from "../../common/buttons/orange_btn/Orange_Btn";
import White_Btn from "../../common/buttons/white_btn/White_Btn";

const Reset_Password = () => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);
  const [message, setMessage] = useState("");
  const [showPass, setshowPass] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const { isSidebarOpen, isAllow, signin, setSignin, GetUser } =
    useContext(Context);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
  } = useForm({});

  const navigate = useNavigate();

  const togglePassVisibility = () => {
    setshowPass((prevState) => !prevState);
  };

  const onSubmit = async (data) => {};

  useEffect(() => {
    if (auth.isLogin) {
      GetUser();
      navigate("/dashboard");
    }
  }, [auth]);

  const [showOtpDiv, setShowOtpDiv] = useState(false);

  return (
    <div className="Login Reset_Password">
      <div className="main_page_holder">
        <div className="vdo_holder">
          <video
            src="/Assets/videos/login.mp4"
            className="Product_vdo"
            muted
            loop
            autoPlay
          />
        </div>

        <div className="backdrop_div">
          <img src="/Assets/Images/login/new_bg2.webp" className="bg_img" />
        </div>
        <div className="backdrop_div_dark"></div>

        <div className="login_form">
          {!showOtpDiv && (
            <div className="main_form_div">
              <p className="page_title">Reset Password</p>

              <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group
                  className="mb-3 input_group"
                  controlId="formBasicName"
                >
                  <Form.Control
                    type="text"
                    placeholder="Enter Email"
                    className={classNames("", {
                      "is-invalid": errors?.email,
                    })}
                    {...register("email", {
                      required: "Email is required",
                    })}
                  />

                  {errors?.email && (
                    <Form.Text className="text-danger">
                      {errors?.email?.message}
                    </Form.Text>
                  )}
                </Form.Group>

                <div className="footer_div two_btn">
                  <White_Btn
                    btnText="Submit"
                    onClick={() => {
                      setShowOtpDiv(true);
                    }}
                  />
                  <White_Btn btnText="Cancel" onClick={() => navigate("/")} />
                </div>
              </Form>
            </div>
          )}

          {showOtpDiv && (
            <div className="main_form_div">
              <p className="page_title">Enter OTP</p>

              <Form onSubmit={handleSubmit(onSubmit)}>
                <Form.Group
                  className="mb-3 input_group"
                  controlId="formBasicName"
                >
                  <Form.Control
                    type="number"
                    placeholder="Enter OTP"
                    className={classNames("", {
                      "is-invalid": errors?.email,
                    })}
                    {...register("otp", {
                      required: "Email is required",
                    })}
                  />

                  {errors?.email && (
                    <Form.Text className="text-danger">
                      {errors?.email?.message}
                    </Form.Text>
                  )}
                </Form.Group>

                <div className="footer_div two_btn">
                  <White_Btn
                    btnText="Submit"
                    onClick={() => {
                      navigate("/set-new-password");
                    }}
                  />
                  <White_Btn btnText="Resend" onClick={() => navigate("/")} />
                </div>
              </Form>
            </div>
          )}

          <div className="white_box">
            <img
              src="/Assets/Images/sidebar/black_logo.png"
              className="logo_img"
            />
            <p className="welcome_text">Welcome to</p>
            <p className="company_text">PROFCYMA SOLUTIONS</p>
            <p className="balck_text">
              Connect your business with billions of users around the world
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reset_Password;
